VjsAdmin.TestingServers = (function () {
    const $table = $('#testing-servers-table');
    const emailFilterOptions = [];

    const init = function () {
        initTestingServersTable();
        new Main();
        $('#server-status').multiselect({
            numberDisplayed: 2,
            includeSelectAllOption: true,
        });
    };

    const Main = VjsUtility.Controller.extend({
        events: {
            'click .testing-servers-delete': 'deleteServer',
            'click .testing-servers-reboot': 'rebootServer',
            'click .testing-servers-hardreboot': 'hardRebootServer',
            'click .testing-servers-poweron': 'powerOnServer',
            'click .testing-servers-rebuild': 'rebuildServer',
            'click .testing-servers-restore': 'restoreServer',
            'click .testing-servers-renewssl': 'renewSsl',
            'click .testing-servers-resetdns': 'resetDns',
            'click .testing-servers-backup': 'backupServer',
            'change #server-status': 'changeStatus',
            'change #email-filter': 'quickEmailFilter',
            'change #date_start': 'quickDateFilter',
            'change #date_end': 'quickDateFilter',
            'change #text_search': 'quickTextSearch',
            'click #test_search_reset': 'quickTextSearchReset',
        },
        quickDateFilter() {
            $table.bootstrapTable('refresh', {
                url: '/api/servers/?status=deployed,building,delay',
            });
        },
        quickTextSearch() {
            $table.bootstrapTable('refresh', {
                url: '/api/servers/?status=deployed,building,delay,shutdown,terminated',
            });
        },
        quickTextSearchReset() {
            $('#text_search').val('');
            $table.bootstrapTable('refresh', {
                url: '/api/servers/?status=deployed,building,delay',
            });
            document.getElementById('text_search').value = '';
        },
        deleteServer(e) {
            const $el = $(e.currentTarget);
            const serverId = $el.data('id');

            if (!window.confirm('Are you sure you want to delete this server?')) {
                return;
            }

            $el.parent().html('deleting...');

            const req = new VjsUtility.Request();
            req.delete(`/api/servers/${serverId}`)
                .done(() => {
                    VjsUtility.Notification.success({
                        text: 'Successfully deleted server!',
                        time: 4000,
                    });
                })
                .fail((x, h, r) => {
                    console.log(x, h, r);
                    VjsUtility.Notification.error({
                        text: 'Error - look in console',
                        time: 4000,
                    });
                })
                .always(() => {
                    $table.bootstrapTable('refresh');
                });
        },
        rebootServer(e) {
            const $el = $(e.currentTarget);
            const serverId = $el.data('id');

            if (!window.confirm('Are you sure you want to reboot this server?')) {
                return;
            }

            $el.parent().html('rebooting...');

            const req = new VjsUtility.Request();
            req.put(`/api/servers/${serverId}/reboot`)
                .done(() => {
                    VjsUtility.Notification.success({
                        text: 'Successfully started rebooting server!\n\n Please give server 5 minutes to reboot.',
                        time: 6000,
                    });
                })
                .fail((x, h, r) => {
                    console.log(x, h, r);
                    VjsUtility.Notification.error({
                        text: 'Error - look in console',
                        time: 4000,
                    });
                })
                .always(() => {
                    $table.bootstrapTable('refresh');
                });
        },
        hardRebootServer(e) {
            const $el = $(e.currentTarget);
            const serverId = $el.data('id');

            if (!window.confirm('Are you sure you want to hard reboot this server? This could take up to 15 minutes.')) {
                return;
            }

            $el.parent().html('rebooting...');

            const req = new VjsUtility.Request();
            req.put(`/api/servers/${serverId}/hardreboot`)
                .done(() => {
                    VjsUtility.Notification.success({
                        text: 'Successfully requested the server to hard reboot.\n\n Please give server 15 minutes to reboot.',
                        time: 6000,
                    });
                })
                .fail((x, h, r) => {
                    console.log(x, h, r);
                    VjsUtility.Notification.error({
                        text: 'Error - look in console',
                        time: 4000,
                    });
                })
                .always(() => {
                    $table.bootstrapTable('refresh');
                });
        },
        powerOnServer(e) {
            const $el = $(e.currentTarget);
            const serverId = $el.data('id');

            if (!window.confirm('Are you sure you want to turn on this server? This could take up to 15 minutes.')) {
                return;
            }

            $el.parent().html('turning on...');

            const req = new VjsUtility.Request();
            req.put(`/api/servers/${serverId}/hardreboot`)
                .done(() => {
                    VjsUtility.Notification.success({
                        text: 'Successfully requested the server to power on.\n\n Please give server 15 minutes to power on.',
                        time: 6000,
                    });
                })
                .fail((x, h, r) => {
                    console.log(x, h, r);
                    VjsUtility.Notification.error({
                        text: 'Error - look in console',
                        time: 4000,
                    });
                })
                .always(() => {
                    $table.bootstrapTable('refresh');
                });
        },
        rebuildServer(e) {
            const $el = $(e.currentTarget);
            const serverId = $el.data('id');

            if (
                !window.confirm(
                    'Are you sure you want to rebuild this server? Rebuilding a server will delete the server and create a new one.\nNote: It will take 5 minutes for the server to show up.',
                )
            ) {
                return;
            }

            $el.parent().html('rebuilding...');

            const req = new VjsUtility.Request();
            req.put(`/api/servers/${serverId}/rebuild`)
                .done(() => {
                    VjsUtility.Notification.success({
                        text: 'Successfully started rebuilding server!\n\n An email will be sent when the new server is ready.',
                        time: 6000,
                    });
                })
                .fail((x, h, r) => {
                    console.log(x, h, r);
                    VjsUtility.Notification.error({
                        text: 'Error - look in console',
                        time: 4000,
                    });
                })
                .always(() => {
                    $table.bootstrapTable('refresh');
                });
        },
        restoreServer(e) {
            const $el = $(e.currentTarget);
            const serverId = $el.data('id');

            if (!window.confirm('Are you sure you want to restore this server?')) {
                return;
            }

            $el.parent().html('restoring...');

            const req = new VjsUtility.Request();
            req.put(`/api/servers/${serverId}/restore`)
                .done(() => {
                    VjsUtility.Notification.success({
                        text: 'Successfully started restoring server!\n\n An email will be sent when the new server is ready.',
                        time: 6000,
                    });
                })
                .fail((x, h, r) => {
                    console.log(x, h, r);
                    VjsUtility.Notification.error({
                        text: 'Error - look in console',
                        time: 4000,
                    });
                })
                .always(() => {
                    $table.bootstrapTable('refresh');
                });
        },
        renewSsl(e) {
            const $el = $(e.currentTarget);
            const serverId = $el.data('id');

            if (!window.confirm('Are you sure you want to renew the SSL certificate?')) {
                return;
            }

            $el.parent().html('renewing ssl...');

            const req = new VjsUtility.Request();
            req.put(`/api/servers/${serverId}/renewssl`)
                .done(() => {
                    VjsUtility.Notification.success({
                        text: 'Successfully sent the request to the queue to renew the SSL certificate!\n\n An email will be sent when the certificate is ready.',
                        time: 6000,
                    });
                })
                .fail((x, h, r) => {
                    console.log(x, h, r);
                    VjsUtility.Notification.error({
                        text: 'Error - look in console',
                        time: 4000,
                    });
                })
                .always(() => {
                    $table.bootstrapTable('refresh');
                });
        },
        resetDns(e) {
            const $el = $(e.currentTarget);
            const serverId = $el.data('id');

            if (!window.confirm('Are you sure you want to reset the DNS?')) {
                return;
            }

            $el.parent().html('resetting DNS...');

            const req = new VjsUtility.Request();
            req.put(`/api/servers/${serverId}/resetdns`)
                .done(() => {
                    VjsUtility.Notification.success({
                        text: 'Successfully sent the request to the queue to reset the DNS!\n\n Please wait about 15 minutes for the DNS to update.',
                        time: 6000,
                    });
                })
                .fail((x, h, r) => {
                    console.log(x, h, r);
                    VjsUtility.Notification.error({
                        text: 'Error - look in console',
                        time: 4000,
                    });
                })
                .always(() => {
                    $table.bootstrapTable('refresh');
                });
        },
        backupServer(e) {
            const $el = $(e.currentTarget);
            const serverId = $el.data('id');

            if (!window.confirm('Are you sure you want to backup this server?')) {
                return;
            }

            $el.parent().html('backing up server...');

            const req = new VjsUtility.Request();
            req.put(`/api/servers/${serverId}/backup`)
                .done(() => {
                    VjsUtility.Notification.success({
                        text: 'Successfully sent the request to the queue to backup the server!\n\n Please wait about 15 minutes for the server to backup.',
                        time: 6000,
                    });
                })
                .fail((x, h, r) => {
                    console.log(x, h, r);
                    VjsUtility.Notification.error({
                        text: 'Error - look in console',
                        time: 4000,
                    });
                })
                .always(() => {
                    $table.bootstrapTable('refresh');
                });
        },
        changeStatus(e) {
            let params = {};
            params.status = $(e.currentTarget).val();
            params.status = params.status.join(',');
            if (params.status === '') {
                params = {};
            }
            $table.bootstrapTable('refresh', {
                url: `/api/servers/?${new URLSearchParams(params).toString()}`,
            });
        },
        quickEmailFilter() {
            const emailToFilterBy = $('#email-filter').find(':selected').val();
            if (emailToFilterBy !== 'none') {
                const urlString = `/api/servers/?email_filter=${encodeURIComponent(emailToFilterBy)}`;
                $table.bootstrapTable('refresh', { url: urlString });
            } else {
                $table.bootstrapTable('refresh', {
                    url: '/api/servers/?status=deployed,building,delay',
                });
            }
        },
    });

    const initTestingServersTable = function () {
        $table.bootstrapTable({
            ...VjsTable.simpleTableDefaults(),
            table: '#testing-servers-table',
            method: 'get',
            formatNoMatches() {
                return 'No testing servers AT ALL!!!';
            },
            idField: 'jira_id',
            showRefresh: true,
            showColumns: true,
            pagination: true,
            sidePagination: 'server',
            search: false,
            queryParams: (params) => {
                if ($('#date_start').val() !== '' && $('#date_end').val() !== '') {
                    params.date_start = $('#date_start').val();
                    params.date_end = $('#date_end').val();
                }
                params.text_search = $('#text_search').val();
                return params;
            },
            pageList: [25, 50, 100],
            pageSize: 25,
            toolbar: '#table-toolbar',
            toolbarAlign: 'right',
            icons: {
                refresh: 'fa-refresh',
            },
            sortName: 'created_at',
            sortOrder: 'desc',
            url: '/api/servers/?status=deployed,building,delay',
            columns: [
                {
                    title: 'Status',
                    field: 'status',
                    align: 'center',
                    valign: 'middle',
                    class: 'status',
                    sortable: true,
                    searchable: false,
                    visible: true,
                    formatter(value, row) {
                        const status = value.toLowerCase();
                        if (status === 'building') {
                            return `<strong>${status} : ${row.current_status}</strong>`;
                        }
                        return `<strong>${status}</strong>`;
                    },
                },
                {
                    title: 'Name',
                    field: 'description',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    searchable: true,
                },
                {
                    title: 'Age (Days)',
                    field: 'days',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    searchable: false,
                },
                {
                    title: 'Created At',
                    field: 'created_at',
                    align: 'center',
                    valign: 'middle',
                    visible: true,
                    searchable: false,
                    sortable: true,
                },
                {
                    title: 'Jira Id',
                    field: 'ticket',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    searchable: true,
                    formatter(value) {
                        return `<a href='https://strivven.atlassian.net/browse/${value}' target='_blank'>${value}</a>`;
                    },
                },
                {
                    title: 'DNS Prefix',
                    field: 'dns',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    searchable: false,
                    visible: true,
                },
                {
                    title: 'Created By',
                    field: 'email',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    searchable: true,
                },
                {
                    title: 'Public IP',
                    field: 'ip_address',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    searchable: false,
                    visible: true,
                },
                {
                    title: 'Private IP',
                    field: 'ip_private_address',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    searchable: false,
                    visible: true,
                },
                {
                    title: 'Instance ID',
                    field: 'instanceID',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    searchable: false,
                    visible: false,
                },

                {
                    title: 'Actions',
                    field: 'action',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    searchable: false,
                    formatter(value, row) {
                        const status = row.status.toLowerCase();
                        if (status === 'deployed') {
                            return `
                                <a href='/admin/testing-servers/logs/${row.id}' style='margin-right: 5px' class='testing-servers-logs text-success' title='View Logs' target='_blank'><i class='fa fa-file-text'></i></a>
                                <a href='javascript:void(0);' style='margin-right: 5px' class='testing-servers-backup text-primary' data-id ='${row.id}' title ='Backup'><i class='fa fa-save' aria-hidden='true'></i></a>
                                <a href='javascript:void(0);' style='margin-right: 5px' class='testing-servers-reboot' data-id ='${row.id}' title ='Reboot'><i class='fa fa-refresh' aria-hidden='true'></i></a>
                                <a href='javascript:void(0);' style='margin-right: 5px' class='testing-servers-hardreboot text-warning' data-id ='${row.id}' title ='Hard Reboot'><i class='fa fa-recycle' aria-hidden='true'></i></a>
                                <a href='javascript:void(0);' style='margin-right: 5px' class='testing-servers-rebuild text-danger' data-id ='${row.id}' title ='Rebuild'><i class='fa fa-building' aria-hidden='true'></i></a>
                                <a href='javascript:void(0);' style='margin-right: 5px' class='testing-servers-renewssl text-primary' data-id ='${row.id}' title ='Renew SSL'><i class='fa fa-shield-alt' aria-hidden='true'></i></a>
                                <a href='javascript:void(0);' style='margin-right: 5px' class='testing-servers-resetdns text-primary' data-id ='${row.id}' title ='Refresh DNS'><i class='fa fa-network-wired' aria-hidden='true'></i></a>
                                <a href='javascript:void(0);' style='margin-right: 5px' class='testing-servers-delete text-danger' data-id='${row.id}' title='Delete'><i class='fa fa-trash' aria-hidden='true'></i></a>
                            `;
                        }
                        // eslint-disable-next-line no-empty
                        if (status === 'shutdown') {
                            return `
                            <a href='javascript:void(0);' style='margin-right: 5px' class='testing-servers-poweron text-success' data-id ='${row.id}' title ='Turn On'><i class='fa fa-power-off' aria-hidden='true'></i></a>
                            `;
                        }
                        if (status === 'terminated') {
                            const snapshot = row.snapshotID;
                            if (snapshot !== null) {
                                return `<a href='javascript:void(0);' class='testing-servers-restore text-success' data-id='${row.id}' title="Restore Snapshot"><i class='fa fa-power-off' aria-hidden='true'></i></a>`;
                            }
                            return `<a href='javascript:void(0);' class='text-secondary' disabled="disabled" data-id='${row.id}' title="No Snapshot Available"><i class='fa fa-power-off' aria-hidden='true'></i></a>`;
                        }
                    },
                },
            ],
            responseHandler(res) {
                res.data.forEach((i) => {
                    // eslint-disable-next-line no-underscore-dangle
                    i._data = { status: i.status };
                    if (!emailFilterOptions.includes(i.email)) {
                        $('#email-filter').append(
                            $('<option>', {
                                text: i.email,
                            }),
                        );
                        emailFilterOptions.push(i.email);
                    }
                    return i;
                });
                return {
                    total: res.meta.total ? res.meta.total : 0,
                    rows: res.data,
                };
            },
        });
    };

    return {
        init,
    };
}());
